<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/150kW/150kW.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">150kW Three-in-one Electric Drive Assembly</div>
                <div class="detail-banner-desc transmission">3-in-1 electric drive assembly compatible with differential lock and
                    half-shaft disconnection device
                    <div>
                        High Integrated: Compatible with differential lock and half-shaft disconnection functions;<br />
                    </div>
                    <div>
                        Lightweight with a high torque-to-weight ratio;<br />
                    </div>
                    <div>
                        Excellent NVH Performance: Low-harmonic winding structure;<br />
                    </div>
                    <div>
                        High Efficiency: Hairpin flat-wire winding, high slot fill rate, high-efficiency bearings,
                        reduced oil volume, with a maximum system efficiency of 94%.
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/150kW/150kW-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">150kW</div>
                                    <div class="k">Peak Power</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">16500rpm</div>
                                    <div class="k">Max Speed</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">3356N·m</div>
                                    <div class="k">Peak Torque</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1</div>
                                    <div class="k">Gear</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">487*457*371</div>
                                    <div class="k">Dimension X*Y*Z(mm)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">79kg</div>
                                    <div class="k">Weight</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '150kW Three-in-one Electric Drive Assembly - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/transmission/150.html'

};

import { createApp } from 'vue';
import App from './150.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./150.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
